import { useState } from 'react'

import { Badge } from '@wartek-id/badge'
import { Button } from '@wartek-id/button-v1'

import { CardNotificationBase } from 'app/KinerjaNotifikasiPage/components/CardNotification/CardNotificationBase'
import { PelaksanaanAppealApprovalDialog } from 'app/KinerjaGpkPage/components/PelaksanaanAppeal/PelaksanaanAppealApprovalDialog'
import { PelaksanaanAppealRejectionDialog } from 'app/KinerjaGpkPage/components/PelaksanaanAppeal/PelaksanaanAppealRejectionDialog'

import type { CardNotificationBaseProps } from 'app/KinerjaNotifikasiPage/components/CardNotification/CardNotificationBase'
import type {
  TPelaksanaanAppealState,
  TPelaksanaanAppealableStep,
} from 'types/kinerja-pelaksanaan'

type CardNotificationGpkPelaksanaanAppealApprovalProps =
  CardNotificationBaseProps & {
    appealState?: TPelaksanaanAppealState
    pegawaiName: string
    notificationId?: string
    currentStep: TPelaksanaanAppealableStep
  }

export function CardNotificationGpkPelaksanaanAppealApproval({
  appealState,
  pegawaiName,
  notificationId,
  currentStep,
  ...cardProps
}: CardNotificationGpkPelaksanaanAppealApprovalProps) {
  // ----------------------------------------------------
  // Handle dialog
  // ----------------------------------------------------
  const [activeDialog, setActiveDialog] = useState<
    'NONE' | 'APPEAL_APPROVAL' | 'APPEAL_REJECTION'
  >('NONE')

  const handleCloseDialog = () => setActiveDialog('NONE')

  const handleApprove = () => {
    setActiveDialog('APPEAL_APPROVAL')
  }

  const handleReject = () => {
    setActiveDialog('APPEAL_REJECTION')
  }

  // ----------------------------------------------------
  // Render result element
  // ----------------------------------------------------
  const renderResult = (
    state: CardNotificationGpkPelaksanaanAppealApprovalProps['appealState']
  ) => {
    switch (state) {
      case 'APPROVED':
        return <Badge variant="success">Pengajuan sudah diterima</Badge>
      case 'REJECTED':
        return <Badge>Pengajuan sudah ditolak</Badge>
      default:
        return (
          <>
            <Button size="sm" color="blue" onClick={handleApprove}>
              Terima dan ulangi hasil penilaian
            </Button>
            <Button
              size="sm"
              color="blue"
              variant="ghost"
              onClick={handleReject}
            >
              Tolak pengajuan
            </Button>
          </>
        )
    }
  }

  return (
    <CardNotificationBase {...cardProps}>
      <div className="flex space-x-6 mt-6">{renderResult(appealState)}</div>

      {activeDialog === 'APPEAL_APPROVAL' && (
        <PelaksanaanAppealApprovalDialog
          isOpen={true}
          requestId={notificationId}
          currentStep={currentStep}
          onClose={handleCloseDialog}
        />
      )}

      {activeDialog === 'APPEAL_REJECTION' && (
        <PelaksanaanAppealRejectionDialog
          isOpen={true}
          pegawaiName={pegawaiName}
          requestId={notificationId}
          step={currentStep}
          onClose={handleCloseDialog}
        />
      )}
    </CardNotificationBase>
  )
}
